import { CollectionName } from '../../constants';
import { migrateCollections } from '../helpers';
import {
  CurrentMigrationCollectionItem,
  MigratedMigrationCollectionItem,
  MigrationType,
  SingleCollectionMigrationOption,
} from '../types';

const removeCircular = (state: unknown) => {
  const walk = <T>(obj: T) => {
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        if (typeof obj[key] === 'object' && obj[key] !== null) {
          walk(obj[key]);
          continue;
        }
        if (obj[key] === '[Circular Reference]') {
          delete obj[key];
        }
      }
    }
  };

  walk(state);
  return state;
};

const migrateQuestions = (
  initialData: CurrentMigrationCollectionItem,
): MigratedMigrationCollectionItem => {
  const { questionsState, editingState, ...rest } = initialData;

  const editingUpdatedState = removeCircular(editingState);
  /**
   * TODO there is no type for previous unmigrated state
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const questionUpdatedState = questionsState as any;
  if (questionUpdatedState && questionUpdatedState.questionSteps > 10) {
    questionUpdatedState.questionSteps = Math.min(questionUpdatedState.questionSteps, 10);
    questionUpdatedState.questionStep =
      questionUpdatedState.questionStep > 3
        ? questionUpdatedState.questionStep - 1
        : questionUpdatedState.questionStep;

    questionUpdatedState.data = {
      1: questionUpdatedState.data[1],
      2: questionUpdatedState.data[2],
      3: questionUpdatedState.data[4],
      4: questionUpdatedState.data[5],
      5: questionUpdatedState.data[6],
      6: questionUpdatedState.data[7],
      7: questionUpdatedState.data[8],
      8: questionUpdatedState.data[9],
      9: questionUpdatedState.data[10],
      10: questionUpdatedState.data[11],
    } as unknown as Record<string, string>;
    questionUpdatedState.questionSubStep =
      questionUpdatedState.questionStep === 6 && questionUpdatedState.data[6]?.executor ? 1 : 0;
  }
  return {
    ...rest,
    questionsState: questionUpdatedState,
    editingState: editingUpdatedState,
  };
};

const MIGRATION_OPTIONS: SingleCollectionMigrationOption[] = [
  { collectionName: CollectionName.INTERWILLS, migrateItemFunction: migrateQuestions },
];

const migrate: MigrationType['migrate'] = (data) => {
  const migratedData = migrateCollections({
    data,
    migrationOptions: MIGRATION_OPTIONS,
  });

  return migratedData;
};

export const migration5: MigrationType = {
  version: 6,
  migrate,
};
